import React from "react";
import { toggle } from "../../../../util/common";

interface IProps {
    showAsAccordion?: boolean;
    creditProvider?: any;
}
const CreditRatingImpact: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div role="listitem" className="data-row">
                <div className="link-item">
                    {props.showAsAccordion ? (
                        <button
                            type="button"
                            aria-expanded="false"
                            className="link-button"
                            id="btn-credit-rating-impacts"
                            onClick={(e) => toggle("credit-rating-item-impacts-div", "btn-credit-rating-impacts")}
                        >
                            <span className="row link-item">
                                <span className="col-xs col-no-gutter link-text">
                                    <span className="link-title">
                                        <span className="sr-only btn-toggle-status">Show</span> What impacts my Business Credit Score?
                                    </span>
                                </span>
                            </span>
                        </button>
                    ) : (
                        <h5 className="report-sub-title">What impacts my Business Credit Score?</h5>
                    )}

                    <div
                        className="wallet-details"
                        id="credit-rating-item-impacts-div"
                        style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}
                        aria-hidden="true"
                    >
                        <div role="grid" className="data-grid row-height-xs " aria-labelledby="business-impact">
                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="business-impact-balance">
                                        Balances
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="business-impact-balance">
                                        <ul>
                                            <li>Do you have any outstanding balances?</li>
                                            <li>Do you stay within your credit limit?</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {props.creditProvider === "DUNBRADSTREET" && (
                                <div role="row" className="data-row condensed row">
                                    <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="business-impact-dbt">
                                            PAYDEX® Score
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="business-impact-dbt">
                                            <ul>
                                                <li>
                                                    Are you paying your bills on or ahead of time, and making sure your suppliers and lenders are reporting you
                                                    payments to Dun & Bradstreet?
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {props.creditProvider !== "DUNBRADSTREET" && (
                                <div role="row" className="data-row condensed row">
                                    <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="business-impact-dbt">
                                            Days Beyond Term (DBT)
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="business-impact-dbt">
                                            <ul>
                                                <li>Do you make payments on time?</li>
                                                <li>Do you pay on time consistently?</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="business-impact-age-of-business">
                                        Age Of Business
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="business-impact-age-of-business">
                                        <ul>
                                            <li>How long have you been in business?</li>
                                            <li>Have you maintained good business credit during that time?</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CreditRatingImpact;
